import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getBrandByPath } from "@insite/client-framework/Services/BrandService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Brands/Handlers/LoadBrandByPath";

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        const brand = await getBrandByPath(props.parameter);
        props.apiResult = brand;
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            window.location.href = "/NotFoundErrorPage";
            return false;
        }
        throw error;
    }
});